// Simple fetch wrapper; customize if you already have one
import { getSessionLocal } from './sessionLocal';

const BASE_URL = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '') || '';

function authHeaders() {
  const s = getSessionLocal();
  const token = localStorage.getItem('authToken') || '';
  const h = {};
  if (token)      h['Authorization'] = `Bearer ${token}`;
  if (s.tenantId) h['X-Tenant-Id']   = String(s.tenantId);
  if (s.userId)   h['X-User-Id']     = String(s.userId);
  if (s.roleId)   h['X-Role-Id']     = String(s.roleId);
  if (s.role)     h['X-Role']        = s.role;
  return h;
}

export const makeHeaders = (tenantId, extra = {}) => {
  const h = {
    'Content-Type': 'application/json',
    ...(tenantId ? { 'x-tenant-id': String(tenantId) } : {}),
    ...extra,
  };
  return h;
};

export const getJson = async (url, opts = {}) => {
  const res = await fetch(`${BASE_URL}${url}`, {
    credentials: 'include',
    headers: { ...authHeaders(), ...(opts.headers || {}) },
    ...opts,
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
};

export const postJson = async (url, body, opts = {}) => {
  const res = await fetch(`${BASE_URL}${url}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...authHeaders(), ...(opts.headers || {}) },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const err = new Error(data.message || `${res.status} ${res.statusText}`);
    err.response = { status: res.status, data };
    throw err;
  }
  return res.json();
};

export const patchJson = async (url, body, opts = {}) => {
  const res = await fetch(`${BASE_URL}${url}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...authHeaders(), ...(opts.headers || {}) },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
};
